// // // // // import React, { useState } from "react";
// // // // // import { FaEye, FaHeart, FaPlus, FaMinus } from "react-icons/fa";

// // // // // const products = [
// // // // //   {
// // // // //     id: 1,
// // // // //     name: "Apricot Delight Cake (Large)",
// // // // //     price: 1950,
// // // // //     image:
// // // // //       "https://bakelore.com/cdn/shop/files/best-bakery-in-hyderabad-bakelore.png?v=1732015739&width=1920",
// // // // //   },
// // // // //   {
// // // // //     id: 2,
// // // // //     name: "Apricot Delight Cake (Medium)",
// // // // //     price: 1390,
// // // // //     image:
// // // // //       "https://bakelore.com/cdn/shop/files/best-bakery-in-hyderabad-bakelore.png?v=1732015739&width=1920",
// // // // //   },
// // // // //   {
// // // // //     id: 3,
// // // // //     name: "Apricot Delight Cake (Small)",
// // // // //     price: 340,
// // // // //     image:
// // // // //       "https://bakelore.com/cdn/shop/files/best-bakery-in-hyderabad-bakelore.png?v=1732015739&width=1920",
// // // // //   },
// // // // //   {
// // // // //     id: 4,
// // // // //     name: "Apricot Delight Cake (Large)",
// // // // //     price: 1950,
// // // // //     image:
// // // // //       "https://bakelore.com/cdn/shop/files/best-bakery-in-hyderabad-bakelore.png?v=1732015739&width=1920",
// // // // //   },
// // // // // ];

// // // // // const MainProducts = () => {
// // // // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // // // //   const [quantity, setQuantity] = useState(1);

// // // // //   return (
// // // // //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10">
// // // // //       <h2 className="text-3xl font-semibold mb-10 tracking-wide text-gray-800">
// // // // //         APRICOT DELIGHT
// // // // //       </h2>

// // // // //       {/* Product Grid */}
// // // // //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl w-full px-4">
// // // // //         {products.map((product) => (
// // // // //           <div key={product.id} className="bg-white relative group shadow-sm">
// // // // //             <div className="relative overflow-hidden">
// // // // //               <img
// // // // //                 src={product.image}
// // // // //                 alt={product.name}
// // // // //                 className="w-full object-cover transition-transform duration-300 group-hover:scale-105"
// // // // //               />

// // // // //               {/* Hover Overlay */}
// // // // //               <div className="absolute inset-0 bg-white/80 opacity-0 group-hover:opacity-100 transition-all flex flex-col justify-center items-center">
// // // // //                 <div className="flex items-center gap-4 mb-4">
// // // // //                   <button
// // // // //                     onClick={() => {
// // // // //                       setSelectedProduct(product);
// // // // //                       setQuantity(1);
// // // // //                     }}
// // // // //                     className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]"
// // // // //                   >
// // // // //                     <FaEye />
// // // // //                   </button>
// // // // //                   <button className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]">
// // // // //                     <FaHeart />
// // // // //                   </button>
// // // // //                 </div>
// // // // //                 <button className="bg-[#b27d73] text-white px-6 py-2 rounded">
// // // // //                   ADD TO CART
// // // // //                 </button>
// // // // //               </div>
// // // // //             </div>

// // // // //             {/* Product Info */}
// // // // //             <div className="text-center py-5">
// // // // //               <p className="text-gray-700">{product.name}</p>
// // // // //               <p className="text-[#b27d73] font-semibold">
// // // // //                 Rs. {product.price.toFixed(2)}
// // // // //               </p>
// // // // //             </div>
// // // // //           </div>
// // // // //         ))}
// // // // //       </div>

// // // // //       {/* SEE MORE BUTTON */}
// // // // //       <button className="mt-10 bg-[#b27d73] text-white px-6 py-2 rounded">
// // // // //         SEE MORE
// // // // //       </button>

// // // // //       {/* Quickview Modal */}
// // // // //       {selectedProduct && (
// // // // //         <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
// // // // //           <div className="bg-white rounded-lg max-w-2xl w-full flex flex-col md:flex-row p-6 relative animate-fadeIn">
// // // // //             <button
// // // // //               className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
// // // // //               onClick={() => setSelectedProduct(null)}
// // // // //             >
// // // // //               ✕
// // // // //             </button>

// // // // //             <img
// // // // //               src={selectedProduct.image}
// // // // //               alt={selectedProduct.name}
// // // // //               className="w-full md:w-1/2 object-cover rounded"
// // // // //             />

// // // // //             <div className="mt-6 md:mt-0 md:ml-6 flex flex-col justify-center">
// // // // //               <h3 className="text-gray-800 font-semibold text-lg mb-2">
// // // // //                 Bakelore
// // // // //               </h3>
// // // // //               <h2 className="text-xl font-medium text-gray-700 mb-2">
// // // // //                 {selectedProduct.name}
// // // // //               </h2>
// // // // //               <p className="text-[#b27d73] font-semibold mb-6">
// // // // //                 Rs. {selectedProduct.price.toFixed(2)}
// // // // //               </p>

// // // // //               <div className="flex items-center mb-6">
// // // // //                 <span className="mr-4">Quantity:</span>
// // // // //                 <div className="flex items-center border border-gray-400 rounded">
// // // // //                   <button
// // // // //                     className="px-3 py-1"
// // // // //                     onClick={() => setQuantity(Math.max(1, quantity - 1))}
// // // // //                   >
// // // // //                     <FaMinus />
// // // // //                   </button>
// // // // //                   <span className="px-4">{quantity}</span>
// // // // //                   <button
// // // // //                     className="px-3 py-1"
// // // // //                     onClick={() => setQuantity(quantity + 1)}
// // // // //                   >
// // // // //                     <FaPlus />
// // // // //                   </button>
// // // // //                 </div>
// // // // //               </div>

// // // // //               <div className="flex items-center gap-4">
// // // // //                 <button className="bg-[#b27d73] text-white px-6 py-2 rounded">
// // // // //                   ADD TO CART
// // // // //                 </button>
// // // // //                 <button className="border border-gray-400 p-2 rounded">
// // // // //                   <FaHeart />
// // // // //                 </button>
// // // // //               </div>
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default MainProducts;


// // // // import React, { useState } from "react";
// // // // import { FaEye, FaHeart, FaPlus, FaMinus } from "react-icons/fa";
// // // // import emailjs from "@emailjs/browser";

// // // // const products = [
// // // //   {
// // // //     id: 1,
// // // //     name: "Apricot Delight Cake (Large)",
// // // //     price: 1950,
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // //   {
// // // //     id: 2,
// // // //     name: "Apricot Delight Cake (Medium)",
// // // //     price: 1390,
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // //   {
// // // //     id: 3,
// // // //     name: "Apricot Delight Cake (Small)",
// // // //     price: 340,
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // //   {
// // // //     id: 4,
// // // //     name: "Apricot Delight Cake (Large)",
// // // //     price: 1950,
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // // ];

// // // // const MainProducts = () => {
// // // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // // //   const [quantity, setQuantity] = useState(1);
// // // //   const [showForm, setShowForm] = useState(false);
// // // //   const [formData, setFormData] = useState({
// // // //     name: "",
// // // //     contact: "",
// // // //     email: "",
// // // //     message: "",
// // // //     product: "",
// // // //   });

// // // //   // ✅ EmailJS send function
// // // //   const handleFormSubmit = (e) => {
// // // //     e.preventDefault();

// // // //     emailjs
// // // //       .send(
// // // //         "YOUR_SERVICE_ID", // 🔹 replace with your EmailJS Service ID
// // // //         "YOUR_TEMPLATE_ID", // 🔹 replace with your EmailJS Template ID
// // // //         formData,
// // // //         "YOUR_PUBLIC_KEY" // 🔹 replace with your EmailJS Public Key
// // // //       )
// // // //       .then(
// // // //         () => {
// // // //           alert("✅ Form submitted successfully!");
// // // //           setShowForm(false);
// // // //         },
// // // //         (error) => {
// // // //           console.error("❌ Error sending form:", error);
// // // //           alert("Something went wrong. Please try again.");
// // // //         }
// // // //       );
// // // //   };

// // // //   return (
// // // //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10">
// // // //       <h2 className="text-3xl font-semibold mb-10 tracking-wide text-gray-800">
// // // //         APRICOT DELIGHT
// // // //       </h2>

// // // //       {/* Product Grid */}
// // // //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-7xl w-full px-6">
// // // //         {products.map((product) => (
// // // //           <div
// // // //             key={product.id}
// // // //             className="bg-white relative group shadow-md rounded-lg overflow-hidden"
// // // //           >
// // // //             <div className="relative overflow-hidden">
// // // //               <img
// // // //                 src={product.image}
// // // //                 alt={product.name}
// // // //                 className="w-full h-[220px] object-cover transition-transform duration-300 group-hover:scale-105"
// // // //               />

// // // //               {/* Hover Overlay */}
// // // //               <div className="absolute inset-0 bg-white/80 opacity-0 group-hover:opacity-100 transition-all flex flex-col justify-center items-center">
// // // //                 <div className="flex items-center gap-4 mb-4">
// // // //                   <button
// // // //                     onClick={() => {
// // // //                       setSelectedProduct(product);
// // // //                       setQuantity(1);
// // // //                     }}
// // // //                     className="w-12 h-12 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]"
// // // //                   >
// // // //                     <FaEye size={18} />
// // // //                   </button>
// // // //                   <button className="w-12 h-12 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]">
// // // //                     <FaHeart size={18} />
// // // //                   </button>
// // // //                 </div>
// // // //                 <button
// // // //                   onClick={() => {
// // // //                     setFormData({ ...formData, product: product.name });
// // // //                     setShowForm(true);
// // // //                   }}
// // // //                   className="bg-[#b27d73] text-white px-8 py-3 rounded text-sm font-semibold hover:bg-[#a37368]"
// // // //                 >
// // // //                   ADD TO CART
// // // //                 </button>
// // // //               </div>
// // // //             </div>

// // // //             {/* Product Info */}
// // // //             <div className="text-center py-6">
// // // //               <p className="text-lg text-gray-800">{product.name}</p>
// // // //               <p className="text-[#b27d73] font-semibold text-lg mt-1">
// // // //                 Rs. {product.price.toFixed(2)}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* SEE MORE BUTTON */}
// // // //       <button className="mt-12 bg-[#b27d73] text-white px-8 py-3 rounded hover:bg-[#a37368] text-sm font-medium">
// // // //         SEE MORE
// // // //       </button>

// // // //       {/* Quickview Modal */}
// // // //       {selectedProduct && (
// // // //         <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
// // // //           <div className="bg-white rounded-lg max-w-3xl w-full flex flex-col md:flex-row p-6 relative animate-fadeIn">
// // // //             <button
// // // //               className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
// // // //               onClick={() => setSelectedProduct(null)}
// // // //             >
// // // //               ✕
// // // //             </button>

// // // //             <img
// // // //               src={selectedProduct.image}
// // // //               alt={selectedProduct.name}
// // // //               className="w-full md:w-1/2 h-[400px] object-cover rounded"
// // // //             />

// // // //             <div className="mt-6 md:mt-0 md:ml-6 flex flex-col justify-center">
// // // //               <h3 className="text-gray-800 font-semibold text-lg mb-2">
// // // //                 Bakelore
// // // //               </h3>
// // // //               <h2 className="text-2xl font-medium text-gray-700 mb-2">
// // // //                 {selectedProduct.name}
// // // //               </h2>
// // // //               <p className="text-[#b27d73] font-semibold mb-6 text-lg">
// // // //                 Rs. {selectedProduct.price.toFixed(2)}
// // // //               </p>

// // // //               <div className="flex items-center mb-6">
// // // //                 <span className="mr-4 text-gray-700 font-medium">Quantity:</span>
// // // //                 <div className="flex items-center border border-gray-400 rounded">
// // // //                   <button
// // // //                     className="px-4 py-2"
// // // //                     onClick={() => setQuantity(Math.max(1, quantity - 1))}
// // // //                   >
// // // //                     <FaMinus />
// // // //                   </button>
// // // //                   <span className="px-5 text-lg">{quantity}</span>
// // // //                   <button
// // // //                     className="px-4 py-2"
// // // //                     onClick={() => setQuantity(quantity + 1)}
// // // //                   >
// // // //                     <FaPlus />
// // // //                   </button>
// // // //                 </div>
// // // //               </div>

// // // //               <div className="flex items-center gap-4">
// // // //                 <button
// // // //                   className="bg-[#b27d73] text-white px-8 py-3 rounded font-medium hover:bg-[#a37368]"
// // // //                   onClick={() => {
// // // //                     setFormData({ ...formData, product: selectedProduct.name });
// // // //                     setShowForm(true);
// // // //                   }}
// // // //                 >
// // // //                   ADD TO CART
// // // //                 </button>
// // // //                 <button className="border border-gray-400 p-3 rounded hover:bg-gray-100">
// // // //                   <FaHeart />
// // // //                 </button>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {/* Add to Cart Form Modal */}
// // // //       {showForm && (
// // // //         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
// // // //           <form
// // // //             onSubmit={handleFormSubmit}
// // // //             className="bg-white rounded-lg w-[90%] max-w-md p-6 relative animate-fadeIn"
// // // //           >
// // // //             <button
// // // //               className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
// // // //               onClick={() => setShowForm(false)}
// // // //               type="button"
// // // //             >
// // // //               ✕
// // // //             </button>

// // // //             <h2 className="text-2xl font-semibold mb-4 text-center text-[#b27d73]">
// // // //               Add to Cart
// // // //             </h2>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Name</label>
// // // //               <input
// // // //                 type="text"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.name}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, name: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Contact</label>
// // // //               <input
// // // //                 type="text"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.contact}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, contact: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Email</label>
// // // //               <input
// // // //                 type="email"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.email}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, email: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Product</label>
// // // //               <input
// // // //                 type="text"
// // // //                 className="w-full border px-3 py-2 rounded bg-gray-100"
// // // //                 readOnly
// // // //                 value={formData.product}
// // // //               />
// // // //             </div>

// // // //             <div className="mb-4">
// // // //               <label className="block text-gray-700 mb-1">Message</label>
// // // //               <textarea
// // // //                 rows="3"
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.message}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, message: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <button
// // // //               type="submit"
// // // //               className="bg-[#b27d73] text-white px-6 py-2 w-full rounded hover:bg-[#a76d63]"
// // // //             >
// // // //               Submit
// // // //             </button>
// // // //           </form>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default MainProducts;



// // // // import React, { useState } from "react";
// // // // import { FaEye, FaHeart, FaPlus, FaMinus } from "react-icons/fa";
// // // // import emailjs from "@emailjs/browser";

// // // // const products = [
// // // //   {
// // // //     id: 1,
// // // //     name: "Apricot Delight Cake (Large)",
// // // //     price: 1950,
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // //   {
// // // //     id: 2,
// // // //     name: "Apricot Delight Cake (Medium)",
// // // //     price: 1390,
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // //   {
// // // //     id: 3,
// // // //     name: "Apricot Delight Cake (Small)",
// // // //     price: 340,
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // //   {
// // // //     id: 4,
// // // //     name: "Apricot Delight Cake (Large)",
// // // //     price: 1950,
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // // ];

// // // // const MainProducts = () => {
// // // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // // //   const [quantity, setQuantity] = useState(1);
// // // //   const [showForm, setShowForm] = useState(false);
// // // //   const [formData, setFormData] = useState({
// // // //     name: "",
// // // //     contact: "",
// // // //     email: "",
// // // //     message: "",
// // // //     product: "",
// // // //   });

// // // //   const handleFormSubmit = (e) => {
// // // //     e.preventDefault();

// // // //     emailjs
// // // //       .send(
// // // //         "YOUR_SERVICE_ID",
// // // //         "YOUR_TEMPLATE_ID",
// // // //         formData,
// // // //         "YOUR_PUBLIC_KEY"
// // // //       )
// // // //       .then(
// // // //         () => {
// // // //           alert("✅ Form submitted successfully!");
// // // //           setShowForm(false);
// // // //         },
// // // //         (error) => {
// // // //           console.error("❌ Error sending form:", error);
// // // //           alert("Something went wrong. Please try again.");
// // // //         }
// // // //       );
// // // //   };

// // // //   return (
// // // //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10">
// // // //       <h2 className="text-3xl font-semibold mb-10 tracking-wide text-gray-800">
// // // //         APRICOT DELIGHT
// // // //       </h2>

// // // //       {/* ✅ Product Grid - 4 per row */}
// // // //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full px-6">
// // // //         {products.map((product) => (
// // // //           <div
// // // //             key={product.id}
// // // //             className="bg-white relative group shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300"
// // // //           >
// // // //             <div className="relative overflow-hidden">
// // // //               <img
// // // //                 src={product.image}
// // // //                 alt={product.name}
// // // //                 className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
// // // //               />

// // // //               {/* Hover Overlay */}
// // // //               <div className="absolute inset-0 bg-white/80 opacity-0 group-hover:opacity-100 transition-all flex flex-col justify-center items-center">
// // // //                 <div className="flex items-center gap-4 mb-4">
// // // //                   <button
// // // //                     onClick={() => {
// // // //                       setSelectedProduct(product);
// // // //                       setQuantity(1);
// // // //                     }}
// // // //                     className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]"
// // // //                   >
// // // //                     <FaEye size={16} />
// // // //                   </button>
// // // //                   <button className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]">
// // // //                     <FaHeart size={16} />
// // // //                   </button>
// // // //                 </div>
// // // //                 <button
// // // //                   onClick={() => {
// // // //                     setFormData({ ...formData, product: product.name });
// // // //                     setShowForm(true);
// // // //                   }}
// // // //                   className="bg-[#b27d73] text-white px-6 py-2 rounded text-sm font-semibold hover:bg-[#a37368]"
// // // //                 >
// // // //                   ADD TO CART
// // // //                 </button>
// // // //               </div>
// // // //             </div>

// // // //             {/* Product Info */}
// // // //             <div className="text-center py-5">
// // // //               <p className="text-lg text-gray-800">{product.name}</p>
// // // //               <p className="text-[#b27d73] font-semibold text-lg mt-1">
// // // //                 Rs. {product.price.toFixed(2)}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* SEE MORE BUTTON */}
// // // //       <button className="mt-12 bg-[#b27d73] text-white px-8 py-3 rounded hover:bg-[#a37368] text-sm font-medium">
// // // //         SEE MORE
// // // //       </button>

// // // //       {/* Quickview Modal */}
// // // //       {selectedProduct && (
// // // //         <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
// // // //           <div className="bg-white rounded-lg max-w-3xl w-full flex flex-col md:flex-row p-6 relative animate-fadeIn">
// // // //             <button
// // // //               className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
// // // //               onClick={() => setSelectedProduct(null)}
// // // //             >
// // // //               ✕
// // // //             </button>

// // // //             <img
// // // //               src={selectedProduct.image}
// // // //               alt={selectedProduct.name}
// // // //               className="w-full md:w-1/2 h-[400px] object-cover rounded"
// // // //             />

// // // //             <div className="mt-6 md:mt-0 md:ml-6 flex flex-col justify-center">
// // // //               <h3 className="text-gray-800 font-semibold text-lg mb-2">
// // // //                 Bakelore
// // // //               </h3>
// // // //               <h2 className="text-2xl font-medium text-gray-700 mb-2">
// // // //                 {selectedProduct.name}
// // // //               </h2>
// // // //               <p className="text-[#b27d73] font-semibold mb-6 text-lg">
// // // //                 Rs. {selectedProduct.price.toFixed(2)}
// // // //               </p>

// // // //               <div className="flex items-center mb-6">
// // // //                 <span className="mr-4 text-gray-700 font-medium">Quantity:</span>
// // // //                 <div className="flex items-center border border-gray-400 rounded">
// // // //                   <button
// // // //                     className="px-4 py-2"
// // // //                     onClick={() => setQuantity(Math.max(1, quantity - 1))}
// // // //                   >
// // // //                     <FaMinus />
// // // //                   </button>
// // // //                   <span className="px-5 text-lg">{quantity}</span>
// // // //                   <button
// // // //                     className="px-4 py-2"
// // // //                     onClick={() => setQuantity(quantity + 1)}
// // // //                   >
// // // //                     <FaPlus />
// // // //                   </button>
// // // //                 </div>
// // // //               </div>

// // // //               <div className="flex items-center gap-4">
// // // //                 <button
// // // //                   className="bg-[#b27d73] text-white px-8 py-3 rounded font-medium hover:bg-[#a37368]"
// // // //                   onClick={() => {
// // // //                     setFormData({ ...formData, product: selectedProduct.name });
// // // //                     setShowForm(true);
// // // //                   }}
// // // //                 >
// // // //                   ADD TO CART
// // // //                 </button>
// // // //                 <button className="border border-gray-400 p-3 rounded hover:bg-gray-100">
// // // //                   <FaHeart />
// // // //                 </button>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {/* Add to Cart Form */}
// // // //       {showForm && (
// // // //         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
// // // //           <form
// // // //             onSubmit={handleFormSubmit}
// // // //             className="bg-white rounded-lg w-[90%] max-w-md p-6 relative animate-fadeIn"
// // // //           >
// // // //             <button
// // // //               className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
// // // //               onClick={() => setShowForm(false)}
// // // //               type="button"
// // // //             >
// // // //               ✕
// // // //             </button>

// // // //             <h2 className="text-2xl font-semibold mb-4 text-center text-[#b27d73]">
// // // //               Add to Cart
// // // //             </h2>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Name</label>
// // // //               <input
// // // //                 type="text"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.name}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, name: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Contact</label>
// // // //               <input
// // // //                 type="text"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.contact}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, contact: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Email</label>
// // // //               <input
// // // //                 type="email"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.email}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, email: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Product</label>
// // // //               <input
// // // //                 type="text"
// // // //                 className="w-full border px-3 py-2 rounded bg-gray-100"
// // // //                 readOnly
// // // //                 value={formData.product}
// // // //               />
// // // //             </div>

// // // //             <div className="mb-4">
// // // //               <label className="block text-gray-700 mb-1">Message</label>
// // // //               <textarea
// // // //                 rows="3"
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.message}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, message: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <button
// // // //               type="submit"
// // // //               className="bg-[#b27d73] text-white px-6 py-2 w-full rounded hover:bg-[#a76d63]"
// // // //             >
// // // //               Submit
// // // //             </button>
// // // //           </form>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default MainProducts;


// // // // import React, { useState } from "react";
// // // // import emailjs from "@emailjs/browser";
// // // // import { FaEye, FaHeart } from "react-icons/fa";

// // // // // ✅ Products grouped by category
// // // // const allProducts = [
// // // //   {
// // // //     id: 1,
// // // //     name: "Apricot Delight Cake (Large)",
// // // //     price: 1950,
// // // //     category: "Cakes",
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // //   {
// // // //     id: 2,
// // // //     name: "Apricot Delight Cake (Medium)",
// // // //     price: 1390,
// // // //     category: "Cakes",
// // // //     image:
// // // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // // //   },
// // // //   {
// // // //     id: 3,
// // // //     name: "Chocolate Pastry",
// // // //     price: 180,
// // // //     category: "Pastries",
// // // //     image:
// // // //       "http://bakelore.com/images/cake_bakelore-min.png",
// // // //   },
// // // //   {
// // // //     id: 4,
// // // //     name: "Vanilla Muffin",
// // // //     price: 120,
// // // //     category: "Muffins",
// // // //     image:
// // // //       "http://bakelore.com/images/daily_breakfast_bakelore-min.png",
// // // //   },
// // // //   {
// // // //     id: 5,
// // // //     name: "Red Velvet Cupcake",
// // // //     price: 150,
// // // //     category: "Cupcakes",
// // // //     image:
// // // //       "http://bakelore.com/images/desserts_bakelore-min.png",
// // // //   },
// // // // ];

// // // // const MainProducts = () => {
// // // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // // //   const [showForm, setShowForm] = useState(false);
// // // //   const [category, setCategory] = useState("All");

// // // //   const [formData, setFormData] = useState({
// // // //     name: "",
// // // //     contact: "",
// // // //     email: "",
// // // //     message: "",
// // // //     product: "",
// // // //   });

// // // //   // ✅ Filter products by category
// // // //   const filteredProducts =
// // // //     category === "All"
// // // //       ? allProducts
// // // //       : allProducts.filter((p) => p.category === category);

// // // //   const handleFormSubmit = (e) => {
// // // //     e.preventDefault();
// // // //     emailjs
// // // //       .send(
// // // //         "YOUR_SERVICE_ID",
// // // //         "YOUR_TEMPLATE_ID",
// // // //         formData,
// // // //         "YOUR_PUBLIC_KEY"
// // // //       )
// // // //       .then(
// // // //         () => {
// // // //           alert("✅ Order submitted successfully!");
// // // //           setShowForm(false);
// // // //           setFormData({
// // // //             name: "",
// // // //             contact: "",
// // // //             email: "",
// // // //             message: "",
// // // //             product: "",
// // // //           });
// // // //         },
// // // //         (error) => {
// // // //           console.error("❌ Error sending form:", error);
// // // //           alert("Something went wrong. Please try again.");
// // // //         }
// // // //       );
// // // //   };

// // // //   return (
// // // //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6 relative">
// // // //       {/* ✅ Title & Category Dropdown */}
// // // //       <div className="flex justify-between items-center w-full max-w-7xl mb-10">
// // // //         <h2 className="text-3xl font-semibold tracking-wide text-gray-800">
// // // //           Our Products
// // // //         </h2>

// // // //         {/* ✅ Category Filter Dropdown */}
// // // //         <select
// // // //           value={category}
// // // //           onChange={(e) => setCategory(e.target.value)}
// // // //           className="bg-white border border-gray-400 rounded px-4 py-2 text-gray-700 font-medium shadow-sm focus:outline-none"
// // // //         >
// // // //           <option value="All">All Categories</option>
// // // //           <option value="Cakes">Cakes</option>
// // // //           <option value="Pastries">Pastries</option>
// // // //           <option value="Muffins">Muffins</option>
// // // //           <option value="Cupcakes">Cupcakes</option>
// // // //         </select>
// // // //       </div>

// // // //       {/* ✅ Product Grid */}
// // // //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
// // // //         {filteredProducts.map((product) => (
// // // //           <div
// // // //             key={product.id}
// // // //             className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 group"
// // // //           >
// // // //             <div className="relative overflow-hidden">
// // // //               <img
// // // //                 src={product.image}
// // // //                 alt={product.name}
// // // //                 className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
// // // //               />

// // // //               {/* Hover Overlay */}
// // // //               <div className="absolute inset-0 bg-white/80 opacity-0 group-hover:opacity-100 transition-all flex justify-center items-center gap-4">
// // // //                 <button
// // // //                   onClick={() => setSelectedProduct(product)}
// // // //                   className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]"
// // // //                 >
// // // //                   <FaEye size={16} />
// // // //                 </button>
// // // //                 <button className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]">
// // // //                   <FaHeart size={16} />
// // // //                 </button>
// // // //               </div>
// // // //             </div>

// // // //             {/* Product Info */}
// // // //             <div className="text-center py-5">
// // // //               <p className="text-lg text-gray-800 font-medium">
// // // //                 {product.name}
// // // //               </p>
// // // //               <p className="text-[#b27d73] font-semibold text-lg mt-1">
// // // //                 Rs. {product.price.toFixed(2)}
// // // //               </p>

// // // //               {/* ✅ Order Now Button */}
// // // //               <button
// // // //                 onClick={() => {
// // // //                   setFormData({ ...formData, product: product.name });
// // // //                   setShowForm(true);
// // // //                 }}
// // // //                 className="mt-3 bg-[#b27d73] text-white px-6 py-2 rounded text-sm font-semibold hover:bg-[#a37368] transition"
// // // //               >
// // // //                 ORDER NOW
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* ✅ Order Form Popup */}
// // // //       {showForm && (
// // // //         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
// // // //           <form
// // // //             onSubmit={handleFormSubmit}
// // // //             className="bg-white rounded-lg w-[90%] max-w-md p-6 relative animate-fadeIn"
// // // //           >
// // // //             <button
// // // //               className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
// // // //               onClick={() => setShowForm(false)}
// // // //               type="button"
// // // //             >
// // // //               ✕
// // // //             </button>

// // // //             <h2 className="text-2xl font-semibold mb-4 text-center text-[#b27d73]">
// // // //               Order Form
// // // //             </h2>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Name</label>
// // // //               <input
// // // //                 type="text"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.name}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, name: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Contact</label>
// // // //               <input
// // // //                 type="text"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.contact}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, contact: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Email</label>
// // // //               <input
// // // //                 type="email"
// // // //                 required
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.email}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, email: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <div className="mb-3">
// // // //               <label className="block text-gray-700 mb-1">Product</label>
// // // //               <input
// // // //                 type="text"
// // // //                 readOnly
// // // //                 className="w-full border px-3 py-2 rounded bg-gray-100"
// // // //                 value={formData.product}
// // // //               />
// // // //             </div>

// // // //             <div className="mb-4">
// // // //               <label className="block text-gray-700 mb-1">Message</label>
// // // //               <textarea
// // // //                 rows="3"
// // // //                 className="w-full border px-3 py-2 rounded"
// // // //                 value={formData.message}
// // // //                 onChange={(e) =>
// // // //                   setFormData({ ...formData, message: e.target.value })
// // // //                 }
// // // //               />
// // // //             </div>

// // // //             <button
// // // //               type="submit"
// // // //               className="bg-[#b27d73] text-white px-6 py-2 w-full rounded hover:bg-[#a76d63]"
// // // //             >
// // // //               Submit
// // // //             </button>
// // // //           </form>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default MainProducts;



// // // import React, { useState, useRef } from "react";
// // // import emailjs from "@emailjs/browser";
// // // import { FaEye, FaHeart } from "react-icons/fa";
// // // import { Swiper, SwiperSlide } from "swiper/react";
// // // import { Navigation } from "swiper";
// // // import "swiper/css";
// // // import "swiper/css/navigation";

// // // // ✅ Product Data
// // // const allProducts = [
// // //   {
// // //     id: 1,
// // //     name: "Apricot Delight Cake (Large)",
// // //     price: 1950,
// // //     category: "Cakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 2,
// // //     name: "Apricot Delight Cake (Medium)",
// // //     price: 1390,
// // //     category: "Cakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 3,
// // //     name: "Chocolate Pastry",
// // //     price: 180,
// // //     category: "Pastries",
// // //     image:
// // //       "http://bakelore.com/images/cake_bakelore-min.png",
// // //   },
// // //   {
// // //     id: 4,
// // //     name: "Vanilla Muffin",
// // //     price: 120,
// // //     category: "Muffins",
// // //     image:
// // //       "http://bakelore.com/images/daily_breakfast_bakelore-min.png",
// // //   },
// // //   {
// // //     id: 5,
// // //     name: "Red Velvet Cupcake",
// // //     price: 150,
// // //     category: "Cupcakes",
// // //     image:
// // //       "http://bakelore.com/images/desserts_bakelore-min.png",
// // //   },
// // // ];

// // // const MainProducts = () => {
// // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // //   const [showForm, setShowForm] = useState(false);
// // //   const [category, setCategory] = useState("All");
// // //   const [formData, setFormData] = useState({
// // //     name: "",
// // //     contact: "",
// // //     email: "",
// // //     message: "",
// // //     product: "",
// // //   });

// // //   const prevRef = useRef(null);
// // //   const nextRef = useRef(null);

// // //   // ✅ Filter products by category
// // //   const filteredProducts =
// // //     category === "All"
// // //       ? allProducts
// // //       : allProducts.filter((p) => p.category === category);

// // //   const handleFormSubmit = (e) => {
// // //     e.preventDefault();
// // //     emailjs
// // //       .send("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", formData, "YOUR_PUBLIC_KEY")
// // //       .then(
// // //         () => {
// // //           alert("✅ Order submitted successfully!");
// // //           setShowForm(false);
// // //           setFormData({
// // //             name: "",
// // //             contact: "",
// // //             email: "",
// // //             message: "",
// // //             product: "",
// // //           });
// // //         },
// // //         (error) => {
// // //           console.error("❌ Error sending form:", error);
// // //           alert("Something went wrong. Please try again.");
// // //         }
// // //       );
// // //   };

// // //   return (
// // //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6 relative">
// // //       {/* ✅ Title & Category Dropdown */}
// // //       <div className="flex justify-between items-center w-full max-w-7xl mb-10">
// // //         <h2 className="text-3xl font-semibold tracking-wide text-gray-800">
// // //           Our Products
// // //         </h2>

// // //         <select
// // //           value={category}
// // //           onChange={(e) => setCategory(e.target.value)}
// // //           className="bg-white border border-gray-400 rounded px-4 py-2 text-gray-700 font-medium shadow-sm focus:outline-none"
// // //         >
// // //           <option value="All">All Categories</option>
// // //           <option value="Cakes">Cakes</option>
// // //           <option value="Pastries">Pastries</option>
// // //           <option value="Muffins">Muffins</option>
// // //           <option value="Cupcakes">Cupcakes</option>
// // //         </select>
// // //       </div>

// // //       {/* ✅ Desktop Grid */}
// // //       <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
// // //         {filteredProducts.map((product) => (
// // //           <ProductCard
// // //             key={product.id}
// // //             product={product}
// // //             setFormData={setFormData}
// // //             setShowForm={setShowForm}
// // //             setSelectedProduct={setSelectedProduct}
// // //           />
// // //         ))}
// // //       </div>

// // //       {/* ✅ Mobile Swiper with Floating Arrows */}
// // //       <div className="block sm:hidden w-full max-w-xs relative">
// // //         {/* Floating Arrows */}
// // //         <div className="absolute -top-6 left-0 right-0 flex justify-between px-2 z-10">
// // //           <button
// // //             ref={prevRef}
// // //             className="bg-[#b27d73] text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md active:scale-90"
// // //           >
// // //             ❮
// // //           </button>
// // //           <button
// // //             ref={nextRef}
// // //             className="bg-[#b27d73] text-white w-8 h-8 rounded-full flex items-center justify-center shadow-md active:scale-90"
// // //           >
// // //             ❯
// // //           </button>
// // //         </div>

// // //         <Swiper
// // //           modules={[Navigation]}
// // //           spaceBetween={20}
// // //           slidesPerView={1}
// // //           navigation={{
// // //             prevEl: prevRef.current,
// // //             nextEl: nextRef.current,
// // //           }}
// // //           onBeforeInit={(swiper) => {
// // //             swiper.params.navigation.prevEl = prevRef.current;
// // //             swiper.params.navigation.nextEl = nextRef.current;
// // //           }}
// // //           className="w-full pt-8"
// // //         >
// // //           {filteredProducts.map((product) => (
// // //             <SwiperSlide key={product.id}>
// // //               <ProductCard
// // //                 product={product}
// // //                 setFormData={setFormData}
// // //                 setShowForm={setShowForm}
// // //                 setSelectedProduct={setSelectedProduct}
// // //               />
// // //             </SwiperSlide>
// // //           ))}
// // //         </Swiper>
// // //       </div>

// // //       {/* ✅ Order Form Popup */}
// // //       {showForm && (
// // //         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
// // //           <form
// // //             onSubmit={handleFormSubmit}
// // //             className="bg-white rounded-lg w-[90%] max-w-md p-6 relative animate-fadeIn"
// // //           >
// // //             <button
// // //               className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
// // //               onClick={() => setShowForm(false)}
// // //               type="button"
// // //             >
// // //               ✕
// // //             </button>

// // //             <h2 className="text-2xl font-semibold mb-4 text-center text-[#b27d73]">
// // //               Order Form
// // //             </h2>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Name</label>
// // //               <input
// // //                 type="text"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.name}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, name: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Contact</label>
// // //               <input
// // //                 type="text"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.contact}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, contact: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Email</label>
// // //               <input
// // //                 type="email"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.email}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, email: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Product</label>
// // //               <input
// // //                 type="text"
// // //                 readOnly
// // //                 className="w-full border px-3 py-2 rounded bg-gray-100"
// // //                 value={formData.product}
// // //               />
// // //             </div>

// // //             <div className="mb-4">
// // //               <label className="block text-gray-700 mb-1">Message</label>
// // //               <textarea
// // //                 rows="3"
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.message}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, message: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <button
// // //               type="submit"
// // //               className="bg-[#b27d73] text-white px-6 py-2 w-full rounded hover:bg-[#a76d63]"
// // //             >
// // //               Submit
// // //             </button>
// // //           </form>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // // ✅ Product Card Component
// // // const ProductCard = ({
// // //   product,
// // //   setFormData,
// // //   setShowForm,
// // //   setSelectedProduct,
// // // }) => (
// // //   <div className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 group">
// // //     <div className="relative overflow-hidden">
// // //       <img
// // //         src={product.image}
// // //         alt={product.name}
// // //         className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
// // //       />
// // //       <div className="absolute inset-0 bg-white/80 opacity-0 group-hover:opacity-100 transition-all flex justify-center items-center gap-4">
// // //         <button
// // //           onClick={() => setSelectedProduct(product)}
// // //           className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]"
// // //         >
// // //           <FaEye size={16} />
// // //         </button>
// // //         <button className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]">
// // //           <FaHeart size={16} />
// // //         </button>
// // //       </div>
// // //     </div>

// // //     <div className="text-center py-5">
// // //       <p className="text-lg text-gray-800 font-medium">{product.name}</p>
// // //       <p className="text-[#b27d73] font-semibold text-lg mt-1">
// // //         Rs. {product.price.toFixed(2)}
// // //       </p>

// // //       <button
// // //         onClick={() => {
// // //           setFormData((prev) => ({ ...prev, product: product.name }));
// // //           setShowForm(true);
// // //         }}
// // //         className="mt-3 bg-[#b27d73] text-white px-6 py-2 rounded text-sm font-semibold hover:bg-[#a37368] transition"
// // //       >
// // //         ORDER NOW
// // //       </button>
// // //     </div>
// // //   </div>
// // // );

// // // export default MainProducts;


// // // import React, { useState, useRef } from "react";
// // // import emailjs from "@emailjs/browser";
// // // import { FaEye, FaHeart } from "react-icons/fa";
// // // import { Swiper, SwiperSlide } from "swiper/react";
// // // import { Navigation } from "swiper";
// // // import "swiper/css";
// // // import "swiper/css/navigation";

// // // // ✅ Product Data
// // // const allProducts = [
// // //   {
// // //     id: 1,
// // //     name: "Apricot Delight Cake (Large)",
// // //     price: 1950,
// // //     category: "Cakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 2,
// // //     name: "Apricot Delight Cake (Medium)",
// // //     price: 1390,
// // //     category: "Cakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 3,
// // //     name: "Chocolate Pastry",
// // //     price: 180,
// // //     category: "Pastries",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 4,
// // //     name: "Vanilla Muffin",
// // //     price: 120,
// // //     category: "Muffins",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 5,
// // //     name: "Red Velvet Cupcake",
// // //     price: 150,
// // //     category: "Cupcakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // // ];

// // // const MainProducts = () => {
// // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // //   const [showForm, setShowForm] = useState(false);
// // //   const [category, setCategory] = useState("All");
// // //   const [formData, setFormData] = useState({
// // //     name: "",
// // //     contact: "",
// // //     email: "",
// // //     message: "",
// // //     product: "",
// // //   });

// // //   const prevRef = useRef(null);
// // //   const nextRef = useRef(null);

// // //   // ✅ Filter products by category
// // //   const filteredProducts =
// // //     category === "All"
// // //       ? allProducts
// // //       : allProducts.filter((p) => p.category === category);

// // //   const handleFormSubmit = (e) => {
// // //     e.preventDefault();
// // //     emailjs
// // //       .send("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", formData, "YOUR_PUBLIC_KEY")
// // //       .then(
// // //         () => {
// // //           alert("✅ Order submitted successfully!");
// // //           setShowForm(false);
// // //           setFormData({
// // //             name: "",
// // //             contact: "",
// // //             email: "",
// // //             message: "",
// // //             product: "",
// // //           });
// // //         },
// // //         (error) => {
// // //           console.error("❌ Error sending form:", error);
// // //           alert("Something went wrong. Please try again.");
// // //         }
// // //       );
// // //   };

// // //   return (
// // //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6 relative">
// // //       {/* ✅ Title & Category Dropdown */}
// // //       <div className="flex justify-between items-center w-full max-w-7xl mb-10">
// // //         <h2 className="text-3xl font-semibold tracking-wide text-gray-800">
// // //           Our Products
// // //         </h2>

// // //         <select
// // //           value={category}
// // //           onChange={(e) => setCategory(e.target.value)}
// // //           className="bg-white border border-gray-400 rounded px-4 py-2 text-gray-700 font-medium shadow-sm focus:outline-none"
// // //         >
// // //           <option value="All">All Categories</option>
// // //           <option value="Cakes">Cakes</option>
// // //           <option value="Pastries">Pastries</option>
// // //           <option value="Muffins">Muffins</option>
// // //           <option value="Cupcakes">Cupcakes</option>
// // //         </select>
// // //       </div>

// // //       {/* ✅ Desktop Grid */}
// // //       <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
// // //         {filteredProducts.map((product) => (
// // //           <ProductCard
// // //             key={product.id}
// // //             product={product}
// // //             setFormData={setFormData}
// // //             setShowForm={setShowForm}
// // //             setSelectedProduct={setSelectedProduct}
// // //           />
// // //         ))}
// // //       </div>

// // //       {/* ✅ Mobile Swiper with Centered Floating Arrows */}
// // //       <div className="block sm:hidden w-full max-w-xs relative">
// // //         {/* Centered Floating Arrows */}
// // //         <button
// // //           ref={prevRef}
// // //           className="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-3 bg-[#b27d73] text-white w-9 h-9 rounded-full flex items-center justify-center shadow-md active:scale-90 z-10"
// // //         >
// // //           ❮
// // //         </button>
// // //         <button
// // //           ref={nextRef}
// // //           className="absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-3 bg-[#b27d73] text-white w-9 h-9 rounded-full flex items-center justify-center shadow-md active:scale-90 z-10"
// // //         >
// // //           ❯
// // //         </button>

// // //         <Swiper
// // //           modules={[Navigation]}
// // //           spaceBetween={20}
// // //           slidesPerView={1}
// // //           navigation={{
// // //             prevEl: prevRef.current,
// // //             nextEl: nextRef.current,
// // //           }}
// // //           onBeforeInit={(swiper) => {
// // //             swiper.params.navigation.prevEl = prevRef.current;
// // //             swiper.params.navigation.nextEl = nextRef.current;
// // //           }}
// // //           className="w-full"
// // //         >
// // //           {filteredProducts.map((product) => (
// // //             <SwiperSlide key={product.id}>
// // //               <ProductCard
// // //                 product={product}
// // //                 setFormData={setFormData}
// // //                 setShowForm={setShowForm}
// // //                 setSelectedProduct={setSelectedProduct}
// // //               />
// // //             </SwiperSlide>
// // //           ))}
// // //         </Swiper>
// // //       </div>

// // //       {/* ✅ Order Form Popup */}
// // //       {showForm && (
// // //         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
// // //           <form
// // //             onSubmit={handleFormSubmit}
// // //             className="bg-white rounded-lg w-[90%] max-w-md p-6 relative animate-fadeIn"
// // //           >
// // //             <button
// // //               className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
// // //               onClick={() => setShowForm(false)}
// // //               type="button"
// // //             >
// // //               ✕
// // //             </button>

// // //             <h2 className="text-2xl font-semibold mb-4 text-center text-[#b27d73]">
// // //               Order Form
// // //             </h2>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Name</label>
// // //               <input
// // //                 type="text"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.name}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, name: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Contact</label>
// // //               <input
// // //                 type="text"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.contact}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, contact: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Email</label>
// // //               <input
// // //                 type="email"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.email}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, email: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Product</label>
// // //               <input
// // //                 type="text"
// // //                 readOnly
// // //                 className="w-full border px-3 py-2 rounded bg-gray-100"
// // //                 value={formData.product}
// // //               />
// // //             </div>

// // //             <div className="mb-4">
// // //               <label className="block text-gray-700 mb-1">Message</label>
// // //               <textarea
// // //                 rows="3"
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.message}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, message: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <button
// // //               type="submit"
// // //               className="bg-[#b27d73] text-white px-6 py-2 w-full rounded hover:bg-[#a76d63]"
// // //             >
// // //               Submit
// // //             </button>
// // //           </form>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // // ✅ Product Card Component
// // // const ProductCard = ({
// // //   product,
// // //   setFormData,
// // //   setShowForm,
// // //   setSelectedProduct,
// // // }) => (
// // //   <div className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 group">
// // //     <div className="relative overflow-hidden">
// // //       <img
// // //         src={product.image}
// // //         alt={product.name}
// // //         className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
// // //       />
// // //       <div className="absolute inset-0 bg-white/80 opacity-0 group-hover:opacity-100 transition-all flex justify-center items-center gap-4">
// // //         <button
// // //           onClick={() => setSelectedProduct(product)}
// // //           className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]"
// // //         >
// // //           <FaEye size={16} />
// // //         </button>
// // //         <button className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]">
// // //           <FaHeart size={16} />
// // //         </button>
// // //       </div>
// // //     </div>

// // //     <div className="text-center py-5">
// // //       <p className="text-lg text-gray-800 font-medium">{product.name}</p>
// // //       <p className="text-[#b27d73] font-semibold text-lg mt-1">
// // //         Rs. {product.price.toFixed(2)}
// // //       </p>

// // //       <button
// // //         onClick={() => {
// // //           setFormData((prev) => ({ ...prev, product: product.name }));
// // //           setShowForm(true);
// // //         }}
// // //         className="mt-3 bg-[#b27d73] text-white px-6 py-2 rounded text-sm font-semibold hover:bg-[#a37368] transition"
// // //       >
// // //         ORDER NOW
// // //       </button>
// // //     </div>
// // //   </div>
// // // );

// // // export default MainProducts;



// // // import React, { useState, useRef } from "react";
// // // import emailjs from "@emailjs/browser";
// // // import { FaEye, FaHeart } from "react-icons/fa";
// // // import { Swiper, SwiperSlide } from "swiper/react";
// // // import { Navigation } from "swiper";
// // // import "swiper/css";
// // // import "swiper/css/navigation";

// // // // ✅ Product Data with Size Variants
// // // const allProducts = [
// // //   {
// // //     id: 1,
// // //     name: "Apricot Delight Cake",
// // //     category: "Cakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //     sizes: [
// // //       { label: "Small", price: 890 },
// // //       { label: "Medium", price: 1390 },
// // //       { label: "Large", price: 1950 },
// // //     ],
// // //   },
// // //   {
// // //     id: 2,
// // //     name: "Chocolate Pastry",
// // //     category: "Pastries",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //     sizes: [
// // //       { label: "Small", price: 120 },
// // //       { label: "Medium", price: 150 },
// // //       { label: "Large", price: 180 },
// // //     ],
// // //   },
// // //   {
// // //     id: 3,
// // //     name: "Vanilla Muffin",
// // //     category: "Muffins",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //     sizes: [
// // //       { label: "Small", price: 90 },
// // //       { label: "Medium", price: 110 },
// // //       { label: "Large", price: 130 },
// // //     ],
// // //   },
// // //   {
// // //     id: 4,
// // //     name: "Red Velvet Cupcake",
// // //     category: "Cupcakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //     sizes: [
// // //       { label: "Small", price: 100 },
// // //       { label: "Medium", price: 130 },
// // //       { label: "Large", price: 150 },
// // //     ],
// // //   },
// // // ];

// // // const MainProducts = () => {
// // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // //   const [showForm, setShowForm] = useState(false);
// // //   const [category, setCategory] = useState("All");
// // //   const [formData, setFormData] = useState({
// // //     name: "",
// // //     contact: "",
// // //     email: "",
// // //     message: "",
// // //     product: "",
// // //   });

// // //   const prevRef = useRef(null);
// // //   const nextRef = useRef(null);

// // //   const filteredProducts =
// // //     category === "All"
// // //       ? allProducts
// // //       : allProducts.filter((p) => p.category === category);

// // //   const handleFormSubmit = (e) => {
// // //     e.preventDefault();
// // //     emailjs
// // //       .send("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", formData, "YOUR_PUBLIC_KEY")
// // //       .then(
// // //         () => {
// // //           alert("✅ Order submitted successfully!");
// // //           setShowForm(false);
// // //           setFormData({
// // //             name: "",
// // //             contact: "",
// // //             email: "",
// // //             message: "",
// // //             product: "",
// // //           });
// // //         },
// // //         (error) => {
// // //           console.error("❌ Error sending form:", error);
// // //           alert("Something went wrong. Please try again.");
// // //         }
// // //       );
// // //   };

// // //   return (
// // //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6 relative">
// // //       {/* ✅ Title & Category Dropdown */}
// // //       <div className="flex justify-between items-center w-full max-w-7xl mb-10">
// // //         <h2 className="text-3xl font-semibold tracking-wide text-gray-800">
// // //           Our Products
// // //         </h2>

// // //         <select
// // //           value={category}
// // //           onChange={(e) => setCategory(e.target.value)}
// // //           className="bg-white border border-gray-400 rounded px-4 py-2 text-gray-700 font-medium shadow-sm focus:outline-none"
// // //         >
// // //           <option value="All">All Categories</option>
// // //           <option value="Cakes">Cakes</option>
// // //           <option value="Pastries">Pastries</option>
// // //           <option value="Muffins">Muffins</option>
// // //           <option value="Cupcakes">Cupcakes</option>
// // //         </select>
// // //       </div>

// // //       {/* ✅ Desktop Grid */}
// // //       <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
// // //         {filteredProducts.map((product) => (
// // //           <ProductCard
// // //             key={product.id}
// // //             product={product}
// // //             setFormData={setFormData}
// // //             setShowForm={setShowForm}
// // //             setSelectedProduct={setSelectedProduct}
// // //           />
// // //         ))}
// // //       </div>

// // //       {/* ✅ Mobile Swiper */}
// // //       <div className="block sm:hidden w-full max-w-xs relative">
// // //         <button
// // //           ref={prevRef}
// // //           className="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-3 bg-[#b27d73] text-white w-9 h-9 rounded-full flex items-center justify-center shadow-md active:scale-90 z-10"
// // //         >
// // //           ❮
// // //         </button>
// // //         <button
// // //           ref={nextRef}
// // //           className="absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-3 bg-[#b27d73] text-white w-9 h-9 rounded-full flex items-center justify-center shadow-md active:scale-90 z-10"
// // //         >
// // //           ❯
// // //         </button>

// // //         <Swiper
// // //           modules={[Navigation]}
// // //           spaceBetween={20}
// // //           slidesPerView={1}
// // //           navigation={{
// // //             prevEl: prevRef.current,
// // //             nextEl: nextRef.current,
// // //           }}
// // //           onBeforeInit={(swiper) => {
// // //             swiper.params.navigation.prevEl = prevRef.current;
// // //             swiper.params.navigation.nextEl = nextRef.current;
// // //           }}
// // //           className="w-full"
// // //         >
// // //           {filteredProducts.map((product) => (
// // //             <SwiperSlide key={product.id}>
// // //               <ProductCard
// // //                 product={product}
// // //                 setFormData={setFormData}
// // //                 setShowForm={setShowForm}
// // //                 setSelectedProduct={setSelectedProduct}
// // //               />
// // //             </SwiperSlide>
// // //           ))}
// // //         </Swiper>
// // //       </div>

// // //       {/* ✅ Order Form Popup */}
// // //       {showForm && (
// // //         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
// // //           <form
// // //             onSubmit={handleFormSubmit}
// // //             className="bg-white rounded-lg w-[90%] max-w-md p-6 relative animate-fadeIn"
// // //           >
// // //             <button
// // //               className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
// // //               onClick={() => setShowForm(false)}
// // //               type="button"
// // //             >
// // //               ✕
// // //             </button>

// // //             <h2 className="text-2xl font-semibold mb-4 text-center text-[#b27d73]">
// // //               Order Form
// // //             </h2>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Name</label>
// // //               <input
// // //                 type="text"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.name}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, name: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Contact</label>
// // //               <input
// // //                 type="text"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.contact}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, contact: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Email</label>
// // //               <input
// // //                 type="email"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.email}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, email: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Product</label>
// // //               <input
// // //                 type="text"
// // //                 readOnly
// // //                 className="w-full border px-3 py-2 rounded bg-gray-100"
// // //                 value={formData.product}
// // //               />
// // //             </div>

// // //             <div className="mb-4">
// // //               <label className="block text-gray-700 mb-1">Message</label>
// // //               <textarea
// // //                 rows="3"
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.message}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, message: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <button
// // //               type="submit"
// // //               className="bg-[#b27d73] text-white px-6 py-2 w-full rounded hover:bg-[#a76d63]"
// // //             >
// // //               Submit
// // //             </button>
// // //           </form>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // // ✅ Product Card with Size Selection
// // // const ProductCard = ({
// // //   product,
// // //   setFormData,
// // //   setShowForm,
// // //   setSelectedProduct,
// // // }) => {
// // //   const [selectedSize, setSelectedSize] = useState(product.sizes[0]);

// // //   return (
// // //     <div className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 group">
// // //       <div className="relative overflow-hidden">
// // //         <img
// // //           src={product.image}
// // //           alt={product.name}
// // //           className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
// // //         />
// // //         <div className="absolute inset-0 bg-white/80 opacity-0 group-hover:opacity-100 transition-all flex justify-center items-center gap-4">
// // //           <button
// // //             onClick={() => setSelectedProduct(product)}
// // //             className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]"
// // //           >
// // //             <FaEye size={16} />
// // //           </button>
// // //           <button className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]">
// // //             <FaHeart size={16} />
// // //           </button>
// // //         </div>
// // //       </div>

// // //       <div className="text-center py-5">
// // //         <p className="text-lg text-gray-800 font-medium">{product.name}</p>

// // //         {/* ✅ Size Dropdown */}
// // //         <select
// // //           value={selectedSize.label}
// // //           onChange={(e) =>
// // //             setSelectedSize(
// // //               product.sizes.find((s) => s.label === e.target.value)
// // //             )
// // //           }
// // //           className="mt-2 border border-gray-300 rounded px-3 py-1 text-gray-700"
// // //         >
// // //           {product.sizes.map((size) => (
// // //             <option key={size.label} value={size.label}>
// // //               {size.label}
// // //             </option>
// // //           ))}
// // //         </select>

// // //         <p className="text-[#b27d73] font-semibold text-lg mt-2">
// // //           Rs. {selectedSize.price.toFixed(2)}
// // //         </p>

// // //         <button
// // //           onClick={() => {
// // //             setFormData((prev) => ({
// // //               ...prev,
// // //               product: `${product.name} (${selectedSize.label}) - Rs.${selectedSize.price}`,
// // //             }));
// // //             setShowForm(true);
// // //           }}
// // //           className="mt-3 bg-[#b27d73] text-white px-6 py-2 rounded text-sm font-semibold hover:bg-[#a37368] transition"
// // //         >
// // //           ORDER NOW
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default MainProducts;



// // import React from "react";

// // // ✅ Product Data (8 Items)
// // const allProducts = [
// //   {
// //     id: 1,
// //     name: "Apricot Delight Cake",
// //     category: "Cakes",
// //     image:
// //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// //     link: "https://yourwebsite.com/cakes",
// //   },
// //   {
// //     id: 2,
// //     name: "Chocolate Pastry",
// //     category: "Pastries",
// //     image:
// //       "http://bakelore.com/images/chocolate_pastry_bakelore.webp",
// //     link: "https://yourwebsite.com/pastries",
// //   },
// //   {
// //     id: 3,
// //     name: "Macaroons",
// //     category: "Macaroons",
// //     image:
// //       "http://bakelore.com/images/macaroons.webp",
// //     link: "https://yourwebsite.com/muffins",
// //   },
// //   {
// //     id: 4,
// //     name: "Paneer Peri Peri Pizza",
// //     category: "Pizza",
// //     image:
// //       "http://bakelore.com/images/Paneer_Peri_Peri_Pizza.webp",
// //     link: "https://yourwebsite.com/cupcakes",
// //   },
// //   {
// //     id: 5,
// //     name: "Cappuchino",
// //     category: "Hot Coffee",
// //     image:
// //       "http://bakelore.com/images/blueberry_cheesecake_bakelore.webp",
// //     link: "https://yourwebsite.com/cakes",
// //   },
// //   {
// //     id: 6,
// //     name: "Biscoff Brownie",
// //     category: "Brownies",
// //     image:
// //       "http://bakelore.com/images/almond_brownie_bakelore.webp",
// //     link: "https://yourwebsite.com/brownies",
// //   },
// //   {
// //     id: 7,
// //     name: "Coleslaw sandwich (cold)",
// //     category: "Sandwich",
// //     image:
// //       "http://bakelore.com/images/strawberry_tart_bakelore.webp",
// //     link: "https://yourwebsite.com/tarts",
// //   },
// //   {
// //     id: 8,
// //     name: "Chocochip Cookies Jar",
// //     category: "Cookies",
// //     image:
// //       "http://bakelore.com/images/choco_chip_cookie_bakelore.webp",
// //     link: "https://yourwebsite.com/cookies",
// //   },
// // ];

// // const MainProducts = () => {
// //   return (
// //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6">
// //       {/* ✅ Title */}
// //       <h2 className="text-3xl font-semibold tracking-wide text-gray-800 mb-10">
// //         Our Products
// //       </h2>

// //       {/* ✅ Product Grid */}
// //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
// //         {allProducts.map((product) => (
// //           <div
// //             key={product.id}
// //             className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col"
// //           >
// //             <img
// //               src={product.image}
// //               alt={product.name}
// //               className="w-full h-[250px] object-cover"
// //             />
// //             <div className="text-center py-5 flex flex-col items-center flex-grow">
// //               <p className="text-lg text-gray-800 font-medium">
// //                 {product.name}
// //               </p>
// //               <p className="text-sm text-gray-500 mt-1">{product.category}</p>

// //               {/* ✅ Button inside card */}
// //               <a
// //                 href={product.link}
// //                 target="_blank"
// //                 rel="noopener noreferrer"
// //                 className="mt-4 inline-block bg-[#b27d73] text-white px-5 py-2 rounded-lg shadow-md hover:bg-[#a37368] transition-all font-medium"
// //               >
// //                 View All Products →
// //               </a>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default MainProducts;


// // import React from "react";

// // // ✅ Product Data (Updated with given image names)
// // const allProducts = [
// //   {
// //     id: 1,
// //     name: "Chocochip Cookies Jar",
// //     category: "Cookies",
// //     image:
// //       "http://bakelore.com/images/chocochip-cookies-jar.webp",
// //     link: "https://yourwebsite.com/cookies",
// //   },
// //   {
// //     id: 2,
// //     name: "Coleslaw Sandwich (Cold)",
// //     category: "Sandwich",
// //     image:
// //       "http://bakelore.com/images/Coleslaw_Sandwich.webp",
// //     link: "https://yourwebsite.com/sandwiches",
// //   },
// //   {
// //     id: 3,
// //     name: "Biscoff Brownie",
// //     category: "Brownies",
// //     image:
// //       "http://bakelore.com/images/biscoff_brownie_7_11zon_08ac31f6-f150-4f5c-950a-8f6aad3502bd.webp",
// //     link: "https://yourwebsite.com/brownies",
// //   },
// //   {
// //     id: 4,
// //     name: "Cappuccino Coffee",
// //     category: "Hot Coffee",
// //     image:
// //       "http://bakelore.com/images/cappuccino-coffee-bakelore.webp",
// //     link: "https://yourwebsite.com/coffee",
// //   },
// //   {
// //     id: 5,
// //     name: "Paneer Peri Peri Pizza",
// //     category: "Pizza",
// //     image:
// //       "http://bakelore.com/images/Paneer_Peri_Peri_Pizza.webp",
// //     link: "https://yourwebsite.com/pizza",
// //   },
// //   {
// //     id: 6,
// //     name: "Macaroons",
// //     category: "Macaroons",
// //     image:
// //       "http://bakelore.com/images/macaroons.webp",
// //     link: "https://yourwebsite.com/macaroons",
// //   },
// //   {
// //     id: 7,
// //     name: "Chocolate Pastry",
// //     category: "Pastries",
// //     image:
// //       "http://bakelore.com/images/chocolate_pastry_bakelore.webp",
// //     link: "https://yourwebsite.com/pastries",
// //   },
// //   {
// //     id: 8,
// //     name: "Apricot Delight Cake",
// //     category: "Cakes",
// //     image:
// //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// //     link: "https://yourwebsite.com/cakes",
// //   },
// // ];

// // const MainProducts = () => {
// //   return (
// //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6">
// //       {/* ✅ Title */}
// //       <h2 className="text-3xl font-semibold tracking-wide text-gray-800 mb-10">
// //         Our Products
// //       </h2>

// //       {/* ✅ Product Grid */}
// //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
// //         {allProducts.map((product) => (
// //           <div
// //             key={product.id}
// //             className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col"
// //           >
// //             <img
// //               src={product.image}
// //               alt={product.name}
// //               className="w-full h-[250px] object-cover"
// //             />
// //             <div className="text-center py-5 flex flex-col items-center flex-grow">
// //               <p className="text-lg text-gray-800 font-medium">
// //                 {product.name}
// //               </p>
// //               <p className="text-sm text-gray-500 mt-1">{product.category}</p>

// //               {/* ✅ Button inside card */}
// //               <a
// //                 href={product.link}
// //                 target="_blank"
// //                 rel="noopener noreferrer"
// //                 className="mt-4 inline-block bg-[#b27d73] text-white px-5 py-2 rounded-lg shadow-md hover:bg-[#a37368] transition-all font-medium"
// //               >
// //                 View All Products →
// //               </a>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default MainProducts;


// // import React from "react";

// // // ✅ Product Data
// // const allProducts = [
// //   {
// //     id: 1,
// //     name: "Osmania Cookies Jar",
// //     category: "Cookies",
// //     image:
// //       "http://bakelore.com/images/osmania_cookie.webp",
// //     link: "https://yourwebsite.com/cookies",
// //   },
// //   {
// //     id: 2,
// //     name: "Coleslaw Sandwich (Cold)",
// //     category: "Sandwich",
// //     image:
// //       "http://bakelore.com/images/Coleslaw_Sandwich.webp",
// //     link: "https://yourwebsite.com/sandwiches",
// //   },
// //   {
// //     id: 3,
// //     name: "Biscoff Brownie",
// //     category: "Brownies",
// //     image:
// //       "http://bakelore.com/images/biscoff_brownie_7_11zon_08ac31f6-f150-4f5c-950a-8f6aad3502bd.webp",
// //     link: "https://yourwebsite.com/brownies",
// //   },
// //   {
// //     id: 4,
// //     name: "Cappuccino Coffee",
// //     category: "Hot Coffee",
// //     image:
// //       "http://bakelore.com/images/cappuccino-coffee-bakelore.webp",
// //     link: "https://yourwebsite.com/coffee",
// //   },
// //   {
// //     id: 5,
// //     name: "Paneer Peri Peri Pizza",
// //     category: "Pizza",
// //     image:
// //       "http://bakelore.com/images/Paneer_Peri_Peri_Pizza.webp",
// //     link: "https://yourwebsite.com/pizza",
// //   },
// //   {
// //     id: 6,
// //     name: "Macaroons",
// //     category: "Macaroons",
// //     image:
// //       "http://bakelore.com/images/macaroons.webp",
// //     link: "https://yourwebsite.com/macaroons",
// //   },
// //   {
// //     id: 7,
// //     name: "Chocolate Pastry",
// //     category: "Pastries",
// //     image:
// //       "http://bakelore.com/images/chocolate_pastry_bakelore.webp",
// //     link: "https://yourwebsite.com/pastries",
// //   },
// //   {
// //     id: 8,
// //     name: "Apricot Delight Cake",
// //     category: "Cakes",
// //     image:
// //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// //     link: "https://yourwebsite.com/cakes",
// //   },
// // ];

// // const MainProducts = () => {
// //   return (
// //     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6">
// //       {/* ✅ Title */}
// //       <h2
// //         className="text-3xl mb-10 tracking-wide"
// //         style={{ fontFamily: "Philosopher", serif", color: "#2b2b2b" }}
// //       >
// //         Our Products
// //       </h2>

// //       {/* ✅ Product Grid */}
// //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
// //         {allProducts.map((product) => (
// //           <div
// //             key={product.id}
// //             className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col"
// //           >
// //             <img
// //               src={product.image}
// //               alt={product.name}
// //               className="w-full h-[250px] object-cover"
// //             />
// //             <div className="text-center py-5 flex flex-col items-center flex-grow">
// //               <p
// //                 className="text-lg font-medium"
// //                 style={{ fontFamily: "Manrope, sans-serif", color: "#2b2b2b" }}
// //               >
// //                 {product.name}
// //               </p>
// //               <p
// //                 className="text-sm mt-1"
// //                 style={{ fontFamily: "Manrope, sans-serif", color: "#6b6b6b" }}
// //               >
// //                 {product.category}
// //               </p>

// //               {/* ✅ Button inside card */}
// //               <a
// //                 href={product.link}
// //                 target="_blank"
// //                 rel="noopener noreferrer"
// //                 className="mt-4 inline-block bg-[#b27d73] text-white px-5 py-2 rounded-lg shadow-md hover:bg-[#a37368] transition-all font-medium"
// //                 style={{ fontFamily: "Manrope, sans-serif" }}
// //               >
// //                 View All Products →
// //               </a>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default MainProducts;


// import React, { useState, useRef } from "react";
// import emailjs from "@emailjs/browser";

// const allProducts = [
//   {
//     id: 1,
//     name: "Osmania Cookies Jar",
//     category: "Cookies",
//     image: "http://bakelore.com/images/osmania_cookie.webp",
//     link: "https://yourwebsite.com/cookies",
//   },
//   {
//     id: 2,
//     name: "Coleslaw Sandwich (Cold)",
//     category: "Sandwich",
//     image: "http://bakelore.com/images/Coleslaw_Sandwich.webp",
//     link: "https://yourwebsite.com/sandwiches",
//   },
//   {
//     id: 3,
//     name: "Biscoff Brownie",
//     category: "Brownies",
//     image: "http://bakelore.com/images/biscoff_brownie_7_11zon_08ac31f6-f150-4f5c-950a-8f6aad3502bd.webp",
//     link: "https://yourwebsite.com/brownies",
//   },
//   {
//     id: 4,
//     name: "Cappuccino Coffee",
//     category: "Hot Coffee",
//     image: "http://bakelore.com/images/cappuccino-coffee-bakelore.webp",
//     link: "https://yourwebsite.com/coffee",
//   },
//   {
//     id: 5,
//     name: "Paneer Peri Peri Pizza",
//     category: "Pizza",
//     image: "http://bakelore.com/images/Paneer_Peri_Peri_Pizza.webp",
//     link: "https://yourwebsite.com/pizza",
//   },
//   {
//     id: 6,
//     name: "Macaroons",
//     category: "Macaroons",
//     image: "http://bakelore.com/images/macaroons.webp",
//     link: "https://yourwebsite.com/macaroons",
//   },
//   {
//     id: 7,
//     name: "Chocolate Pastry",
//     category: "Pastries",
//     image: "http://bakelore.com/images/chocolate_pastry_bakelore.webp",
//     link: "https://yourwebsite.com/pastries",
//   },
//   {
//     id: 8,
//     name: "Apricot Delight Cake",
//     category: "Cakes",
//     image: "http://bakelore.com/images/apricot_delight_bakelore.webp",
//     link: "https://yourwebsite.com/cakes",
//   },
// ];

// const MainProducts = () => {
//   const [open, setOpen] = useState(false);
//   const form = useRef();
//   const [sending, setSending] = useState(false);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const sendEmail = (e) => {
//     e.preventDefault();
//     setSending(true);

//     // Add current page URL
//     const pageUrlInput = document.createElement("input");
//     pageUrlInput.type = "hidden";
//     pageUrlInput.name = "page_url";
//     pageUrlInput.value = window.location.href;
//     form.current.appendChild(pageUrlInput);

//     emailjs
//       .sendForm(
//         "service_i2h82eb", // ✅ your service ID
//         "template_1a38hyn", // ✅ your template ID
//         form.current,
//         "hjLXq5MC66R977QFn" // ✅ your public key
//       )
//       .then(
//         () => {
//           alert("Message sent successfully!");
//           form.current.reset();
//           setSending(false);
//           handleClose();
//         },
//         () => {
//           alert("Failed to send message. Please try again.");
//           setSending(false);
//         }
//       );
//   };

//   return (
//     <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6">
//       {/* ✅ Title */}
//       <h2
//         className="text-5xl mb-10 tracking-wide"
//         style={{ fontFamily: "philospher", color: "#C08B89" }}
//       >
//         Our Products
//       </h2>

//       {/* ✅ Product Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
//         {allProducts.map((product) => (
//           <div
//             key={product.id}
//             className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col"
//           >
//             <img
//               src={product.image}
//               alt={product.name}
//               className="w-full h-[250px] object-cover"
//             />
//             <div className="text-center py-5 flex flex-col items-center flex-grow">
//               <p
//                 className="text-lg font-medium"
//                 style={{ fontFamily: "Manrope, sans-serif", color: "#2b2b2b" }}
//               >
//                 {product.name}
//               </p>
//               <p
//                 className="text-sm mt-1"
//                 style={{ fontFamily: "Manrope, sans-serif", color: "#6b6b6b" }}
//               >
//                 {product.category}
//               </p>

//               {/* ✅ Button opens popup */}
//               <button
//                 onClick={handleOpen}
//                 className="mt-4 inline-block bg-[#b27d73] text-white px-5 py-2 rounded-lg shadow-md hover:bg-[#a37368] transition-all font-medium"
//                 style={{ fontFamily: "Manrope, sans-serif" }}
//               >
//                 View All Products →
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* ✅ Popup Form */}
//       {open && (
//         <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative">
//             <button
//               onClick={handleClose}
//               className="absolute top-2 right-3 text-gray-500 text-xl font-bold"
//             >
//               ✕
//             </button>
//             <h3
//               className="text-xl font-semibold mb-4 text-center"
//               style={{ fontFamily: "Philosopher", serif" }}
//             >
//               Enquiry Form
//             </h3>

//             <form ref={form} onSubmit={sendEmail} className="flex flex-col gap-3">
//               <input
//                 type="text"
//                 name="first_name"
//                 placeholder="First Name"
//                 required
//                 className="border border-gray-300 p-2 rounded"
//               />
//               <input
//                 type="text"
//                 name="last_name"
//                 placeholder="Last Name"
//                 required
//                 className="border border-gray-300 p-2 rounded"
//               />
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Email"
//                 required
//                 className="border border-gray-300 p-2 rounded"
//               />
//               <input
//                 type="text"
//                 name="phone"
//                 placeholder="Phone"
//                 required
//                 className="border border-gray-300 p-2 rounded"
//               />
//               <input
//                 type="text"
//                 name="product"
//                 placeholder="Product Name (optional)"
//                 className="border border-gray-300 p-2 rounded"
//               />
//               <textarea
//                 name="message"
//                 placeholder="Your message"
//                 rows="4"
//                 required
//                 className="border border-gray-300 p-2 rounded"
//               ></textarea>
//               <button
//                 type="submit"
//                 disabled={sending}
//                 className="bg-[#b27d73] text-white py-2 rounded mt-2 hover:bg-[#C08B89] transition-all"
//               >
//                 {sending ? "Sending..." : "Submit"}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MainProducts;


import React from "react";

const allProducts = [
  {
    id: 4,
    name: "Cakes",
    // category: "Cakes",
    image: "https://bakelore.com/images/Eggless-rasmalai-cake.jpeg",
  },
  {
    id: 2,
    name: "Dessert Boxes",
    // category: "Cakes",
    image: "https://bakelore.com/images/Dutch-chocolate-dream-cake.jpeg",
  },
   {
    id: 7,
    name: "Pastry",
    // category: "Pastries",
    image: "https://bakelore.com/images/belgium-pastry-bakelore.jpg",
  },
  {
    id: 5,
    name: "Stuffed Bun & Butter Puffs",
    // category: "Buns",
    image: "https://bakelore.com/images/Chicken-65-Bun.jpeg",
  },
  {
    id: 3,
    name: "Burger",
    // category: " Burger",
    image: "https://bakelore.com/images/Crispy-Veg-Patty-Burger-bakelore.jpg",
  },

   {
    id: 8,
    name: "Pizza",
    // category: "Pizza",
    image: "https://bakelore.com/images/Chicken-Pataka-Pizza.jpeg",
  },
  {
    id: 8,
    name: "Wraps",
    // category: "Pizza",
    image: "https://bakelore.com/images/Chicken-Nuggets-Zinger-Wrap-bakelore.jpg",
  },{
    id: 8,
    name: "All Day Breakfast",
    // category: "Pizza",
    image: "https://bakelore.com/images/almond-crossaint-bakelore.jpg",
  },{
    id: 8,
    name: "Gift Hampers",
    // category: "Pizza",
    image: "https://bakelore.com/images/Classic-hampers-bakelore.jpg",
  },{
    id: 8,
    name: "Browine & Cookies",
    // category: "Pizza",
    image: "https://bakelore.com/images/best-browines-in-madhapur-bakelore.jpg",
  },{
    id: 8,
    name: "Sandwich",
    // category: "Pizza",
    image: "https://bakelore.com/images/chicken-club-crossaint-sandwich-bakelore.jpg",
  },{
    id: 8,
    name: "Cold Beverages",
    // category: "Pizza",
    image: "https://bakelore.com/images/Mocha-cold-coffee.jpg",
  },

  {   
    id: 1,
    name: "Hot Beverages",
    // category: "Beverages",
    image: "https://bakelore.com/images/hot-coffie.jpg",
  },{   
    id: 1,
    name: "Quesadillas ",
    // category: "Beverages",
    image: "https://bakelore.com/images/Corn&cheese-quesadilla-bakelore.jpg",
  },{   
    id: 1,
    name: "Namkeens",
    // category: "Beverages",
    image: "https://bakelore.com/images/namkeens.jpeg",
  },{   
    id: 1,
    name: "Strawberry Specials",
    // category: "Beverages",
    image: "https://bakelore.com/images/strawberry-cake-near-me.jpg",
  },
  
  
  
  

 
 


];

const MainProducts = () => {
  const whatsappLink =
    "#";

  return (
    <div className="bg-[#dac9c0] min-h-screen flex flex-col items-center py-10 px-6">
      {/* Title */}
      <h2
        className="text-5xl mb-10 tracking-wide"
        style={{ fontFamily: "philospher", color: "#C08B89" }}
      >
        Our Products
      </h2>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
        {allProducts.map((product) => (
          <div
            key={product.id}
            className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col"
          >
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-[250px] object-cover"
            />
            <div className="text-center py-5 flex flex-col items-center flex-grow">
              <p
                className="text-lg font-medium"
                style={{ fontFamily: "Manrope, sans-serif", color: "#2b2b2b" }}
              >
                {product.name}
              </p>
              <p
                className="text-sm mt-1"
                style={{ fontFamily: "Manrope, sans-serif", color: "#6b6b6b" }}
              >
                {product.category}
              </p>

              {/* Button links to WhatsApp */}
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block bg-[#b27d73] text-white px-5 py-2 rounded-lg shadow-md hover:bg-[#a37368] transition-all font-medium"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                Order Now →
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainProducts;
